import React from 'react';
import { SelectFormField, type SelectFormFieldProps } from '~/shared/forms/controls/fields/SelectFormField';
import { useSearch } from '~/util/http/useSearch';

export function PatientDocumentSelectField({
	stayId,
	storedDocumentTypeId,
	noDocumentsLabel = 'No documents found',
	...props
}: Omit<SelectFormFieldProps, 'options' | 'optionType'> & { stayId: string; storedDocumentTypeId: number; noDocumentsLabel?: string }) {
	const { data: storedDocuments, isLoading } = useSearch({
		searchType: 'stored-document',
		filters: [
			{ name: 'stayId', operator: '==', value: stayId },
			{ name: 'storedDocumentTypeId', operator: '==', value: storedDocumentTypeId }
		]
	});

	if (isLoading) {
		return null;
	}

	const options = storedDocuments?.map(x => ({ id: x.id, name: x.originalDocumentName })) ?? [];
	return <SelectFormField options={options} {...props} placeholder="Select a document" noOptionsMessage={noDocumentsLabel} />;
}
